import React, { useState, useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import Typography from "@material-ui/core/Typography";
import { getPaymentInfo } from "../functions";

const PaymentButton = ({ option, selected, onClick }) => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    setInfo(getPaymentInfo(option, selected));
  }, [option, selected]);

  if (!info) return null;

  return (
    <Card raised={info.selected} onClick={onClick} className="payment-button">
      <CardActionArea>
        <CardMedia
          className="media"
          image={`${process.env.PUBLIC_URL}/assets/images/${info.logo}`}
          title={info.title}
        />
        <CardContent className="content">
          <Typography variant="subtitle2">{info.title}</Typography>
          <Typography variant="body2">{info.subtitle}</Typography>
          <Typography variant="body2" color="textSecondary">
            {info.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PaymentButton;
